export default {
  prevText: 'FÃ¶reg',
  nextText: 'NÃ¤sta'
};
